import { textInputRenderer } from './textInputRenderer';
import { Field } from 'react-final-form';
import { EmailSuggestion } from '@wkda/funnel-components';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function emailWithSuggestionInputRenderer(_ref) {
  let {
    emailSuggestionEnabled,
    onSuggestion = () => {},
    name,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [textInputRenderer({
      type: 'email',
      name,
      ...props
    }), emailSuggestionEnabled ? /*#__PURE__*/_jsx(Field, {
      name: name,
      subscription: {
        value: true
      },
      render: _ref2 => {
        let {
          input: {
            value,
            onChange
          }
        } = _ref2;
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(EmailSuggestion, {
            email: value,
            setEmail: email => {
              onChange(email);
              onSuggestion(email);
            }
          })
        });
      }
    }) : null]
  });
}